import React from 'react'

// Components Local
import { TextEditorDisplay } from '../../TextEditor'


const EditorTextDisplay = ({ type, heading, value }) => {
  return (
    <TextEditorDisplay type={type} heading={heading} value={value} />
  )
}

export default EditorTextDisplay
